
import request from './index'
// 登录方法
export function login(data) {
    return request({
        url: '/login',
        headers: {
            isToken: false
        },
        method: 'post',
        data: data
    })
}

// 验证码登录
export function codeLogin(data) {
    return request({
        url: '/codeLogin',
        headers: {
            isToken: false
        },
        method: 'post',
        data: data
    })
}
// 获取二维码登录
export function getQRCode(params) {
    return request({
        url: '/qr/getCode',
        headers: {
            isToken: false
        },
        method: 'get',
        params
    })
}
// 二维码确认登录
export function QRLogin(token) {
    return request({
        url: '/qr/authLogin?token='+token,
        headers: {
            isToken: false
        },
        method: 'post',
    })
}
// 二维码状态查询
export function QRQuery(params) {
    return request({
        url: '/qr/query',
        headers: {
            isToken: false
        },
        method: 'GET',
        params
    })
}


export function register(data) {
    return request({
        url: '/register',
        headers: {
            isToken: false
        },
        method: 'post',
        data: data
    })
}


export function createTeam(data, token) {
    return request({
        url: '/register',
        headers: {
            Authorization: 'Bearer ' + token
        },
        method: 'post',
        data: data
    })
}


// WEBPACK FOOTER //
// ./src/api/login.js